import { RichText } from '@purpur/library';
import styled, { css } from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

type NegativeProps = {
    $isNegative?: boolean;
};
const overrideHybrisLegacy = css`
    ol,
    ul {
        list-style-type: revert;
        padding-left: revert;
        margin-top: revert;
        margin-bottom: revert;
    }

    code,
    kbd {
        font-size: inherit;
        padding: revert;
    }

    blockquote {
        border-left: revert;
        font-size: inherit;
        margin: revert;
        padding: revert;
    }

    hr {
        height: revert;
        margin-top: revert;
        margin-bottom: revert;
        border: revert;
    }

    table {
        border-collapse: revert;
    }
`;
export const StyledRichText = styled(RichText)<NegativeProps>`
    .purpur-rich-text-table-scroll-container {
        position: relative;
        margin-bottom: ${getPurpurSpacing('200')};
    }
    .purpur-rich-text-table-inner-scroll-container {
        overflow-x: auto;
    }
    table {
        background: ${getPurpurColor('backgroundPrimary')};
        position: relative;
        display: table;
        table-layout: fixed;
        border-spacing: 0px;
        min-width: 100%;

        tr {
            position: relative;
            height: 4rem;
        }

        th {
            background-color: ${getPurpurColor('backgroundPrimary')};
            height: 2.5rem;
            border-bottom: 2px solid ${getPurpurColor('transparentBlack150')};
            padding: 0 ${getPurpurSpacing('100')};
            display: table-cell;
            text-align: left;
            vertical-align: middle;
        }

        td {
            padding: 0 ${getPurpurSpacing('100')};
            display: table-cell;
            text-align: left;
            vertical-align: middle;
            height: 4rem;
        }

        tbody tr:nth-child(2n + 1) td {
            background: ${getPurpurColor('backgroundSecondary')};
        }
    }

    ${({ $isNegative }) =>
        $isNegative &&
        css`
            p,
            li::marker,
            blockquote {
                color: ${getPurpurColor('textDefaultNegative')};
            }
            table {
                // Table is white background + dark text, so should ignore negative appearance
                p {
                    color: ${getPurpurColor('textDefault')} !important;
                }
                a { 
                    color: ${getPurpurColor('textInteractivePrimary')}; 
                }
                a:hover {
                    color: ${getPurpurColor('textInteractivePrimaryHover')};
                    background-color: ${getPurpurColor('backgroundInteractiveTransparentHover')};
                }
                a:active {
                    color: ${getPurpurColor('textInteractivePrimaryActive')};
                    background-color: ${getPurpurColor('backgroundInteractiveTransparentActive')};
                }
            }
            }
        `};

    ${overrideHybrisLegacy}
`;

export const RichTextImage = styled.img`
    max-width: 100%;
`;
